import Modal from '@mui/material/Modal'
import { useRouter } from 'next/router'
import { useState, useEffect } from 'react'
import Icon from 'ui/components/Icon'
import { Wrapper, ModalTitle, ModalText, Box, CloseButton } from './styled'

const ModalBasic = ({
  size,
  title,
  open,
  handlerClose,
  children,
  text = '',
  className,
  onRouteChangeClose,
}) => {
  const router = useRouter()
  const [down, setDown] = useState(false)
  const [up, setUp] = useState(false)

  const handler = (event, setState) => {
    const currentTarget = event.currentTarget
    const target = event.target

    if (target.contains(currentTarget)) {
      setState(true)
    }
  }

  const handleMouseDown = (event) => handler(event, setDown)
  const handleMouseUp = (event) => handler(event, setUp)

  useEffect(() => {
    if (up && down) {
      handlerClose()
      setUp(false)
      setDown(false)
    }
  }, [up, down])

  useEffect(() => {
    if (!open || !onRouteChangeClose) return

    const handleRouteChange = () => {
      onRouteChangeClose()
    }

    router.events.on('routeChangeStart', handleRouteChange)

    return () => {
      router.events.off('routeChangeStart', handleRouteChange)
    }
  }, [open, onRouteChangeClose, router.events])

  return (
    <Modal open={!!open} onClose={handlerClose}>
      <Wrapper onMouseDown={handleMouseDown} onMouseUp={handleMouseUp}>
        <Box
          $size={size}
          className={className}
          onClick={(e) => e.stopPropagation()}
        >
          {title && (
            <ModalTitle $size={size} $hasText={!!text}>
              {title}
            </ModalTitle>
          )}
          {!!text && <ModalText>{text}</ModalText>}
          {children}
        </Box>
        <CloseButton onClick={handlerClose}>
          <Icon name="close" size={12} />
        </CloseButton>
      </Wrapper>
    </Modal>
  )
}

export default ModalBasic
